module.exports = __webpack_public_path__ + "media/images/icons/icon-bottle-4022d0f77666ae4892b31627d845ad94.svg";